export const GET_ALL_MARKER_STYLES = "GET_ALL_MARKER_STYLES";
export const RESET_DATA = "RESET_DATA";
export const START_LOADING_MARKER_STYLES = "START_LOADING_MARKER_STYLES";
export const STOP_LOADING_MARKER_STYLES = "STOP_LOADING_MARKER_STYLES";
export const ERROR_LOADING_MARKER_STYLES = "ERROR_LOADING_MARKER_STYLES";